var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm._l(3, function(option) {
        return _vm.loading == true
          ? _c(
              "div",
              {
                staticClass:
                  "row border-class mb-3 pb-2 align-items-center mx-5 ",
                staticStyle: { "border-bottom": "1px solid #CCC" }
              },
              [
                _c("div", { staticClass: "col-7" }, [
                  _c(
                    "div",
                    { staticClass: "col-12" },
                    [_c("PuSkeleton", { attrs: { count: 1 } })],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-10" },
                    [_c("PuSkeleton", { attrs: { count: 1 } })],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-2" }),
                _vm._v(" "),
                _c("div", { staticClass: "col-3" }, [
                  _c(
                    "div",
                    { staticClass: "col-12" },
                    [_c("PuSkeleton", { attrs: { count: 1 } })],
                    1
                  )
                ])
              ]
            )
          : _vm._e()
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "mentee-progress-list" },
        _vm._l(_vm.progress, function(objective, index) {
          return objective.objectiveType != "Other Tasks"
            ? _c(
                "div",
                {
                  staticClass:
                    "border-class mb-3 align-items-center mx-3 pr-3 pb-2"
                },
                [
                  _c("div", { staticClass: "row" }, [
                    objective.objectiveType == "External Course"
                      ? _c(
                          "div",
                          {
                            staticClass: "col-1",
                            staticStyle: { "margin-top": "0px" }
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "text-uppercase h3 mb-0 text-success"
                              },
                              [
                                _c("img", {
                                  attrs: { src: objective.image, width: "35px" }
                                })
                              ]
                            )
                          ]
                        )
                      : objective.CompletionPercentage == 100
                      ? _c("div", { staticClass: "col-1" }, [_vm._m(0, true)])
                      : objective.CompletionPercentage == 0
                      ? _c("div", { staticClass: "col-1" }, [_vm._m(1, true)])
                      : _c("div", { staticClass: "col-1" }, [
                          _c(
                            "div",
                            {
                              staticClass: "progress-circle",
                              style:
                                "--percent: " +
                                objective.CompletionPercentage +
                                "%;"
                            },
                            [_c("i", { staticClass: "fa fa-check" })]
                          )
                        ]),
                    _vm._v(" "),
                    objective.objectiveType == "Assessment" ||
                    objective.objectiveType == "Course" ||
                    objective.objectiveType == "Form"
                      ? _c("div", { staticClass: "col-7 col-xl-7" }, [
                          _c("p", { staticClass: "mb-0" }, [
                            _vm._v(_vm._s(objective.objectiveName))
                          ]),
                          _vm._v(" "),
                          objective.CompletionPercentage == 100
                            ? _c(
                                "p",
                                { staticClass: "small text-muted mb-0" },
                                [
                                  _vm._v(
                                    _vm._s(objective.objectiveType) +
                                      " Completed " +
                                      _vm._s(objective.CompletionDate)
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          objective.CompletionPercentage != 100 &&
                          objective.objectiveType == "Course"
                            ? _c(
                                "p",
                                { staticClass: "small text-muted mb-0" },
                                [
                                  _vm._v(
                                    "Course - " +
                                      _vm._s(objective.courseCompleteCount) +
                                      "/" +
                                      _vm._s(objective.totalCourseCount) +
                                      " Modules Completed"
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          objective.CompletionPercentage != 100 &&
                          objective.objectiveType == "Assessment"
                            ? _c(
                                "p",
                                { staticClass: "small text-muted mb-0" },
                                [_vm._v("Assessment")]
                              )
                            : _vm._e()
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    objective.objectiveType == "Task List"
                      ? _c("div", { staticClass: "col-7 col-xl-7" }, [
                          _c("p", { staticClass: "mb-0" }, [
                            _vm._v(_vm._s(objective.objectiveName))
                          ]),
                          _vm._v(" "),
                          _c("p", { staticClass: "small text-muted mb-0" }, [
                            _vm._v(
                              "Skill Set - " +
                                _vm._s(objective.CompletionPercentage) +
                                "% Complete"
                            )
                          ])
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    objective.objectiveType == "Certificate"
                      ? _c("div", { staticClass: "col-7 col-xl-7" }, [
                          _c("p", { staticClass: "mb-0" }, [
                            _vm._v(
                              "Certifications - " +
                                _vm._s(objective.objectiveName)
                            )
                          ]),
                          _vm._v(" "),
                          _c("p", { staticClass: "small text-muted mb-0" }, [
                            _vm._v(
                              "Certifications - " +
                                _vm._s(objective.completedCertificateCount) +
                                "/" +
                                _vm._s(objective.totalCertificateCount)
                            )
                          ])
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    objective.objectiveType == "External Course"
                      ? _c("div", { staticClass: "col-7 col-xl-7" }, [
                          _c("p", { staticClass: "mb-0" }, [
                            _vm._v(_vm._s(objective.objectiveName))
                          ]),
                          _vm._v(" "),
                          _c("p", { staticClass: "small text-muted mb-0" }, [
                            _vm._v(
                              "External Course " + _vm._s(objective.expires)
                            )
                          ])
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    objective.buttonName == "Incomplete"
                      ? _c(
                          "div",
                          {
                            staticClass: "col-4 col-xl-4 pr-0 text-right",
                            staticStyle: { "padding-left": "5px" }
                          },
                          [
                            _c(
                              "a",
                              {
                                staticClass:
                                  "progress_item_link font-weight-bold",
                                staticStyle: { color: "#333 !important" }
                              },
                              [_vm._v(_vm._s(objective.buttonName) + " ")]
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    objective.objectiveType == "Assessment" &&
                    objective.CompletionPercentage == 100
                      ? _c(
                          "div",
                          {
                            staticClass: "col-4 col-xl-4 pr-0 text-right",
                            staticStyle: { "padding-left": "5px" }
                          },
                          [
                            _c(
                              "a",
                              {
                                staticClass:
                                  "progress_item_link font-weight-bold",
                                on: {
                                  click: function($event) {
                                    return _vm.viewReport(
                                      objective.userAssessmentAttemptId
                                    )
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(objective.buttonName) + " \n        "
                                ),
                                _c("img", {
                                  staticClass: "ml-2 objective-view-icon",
                                  attrs: {
                                    src: require("@/assets/manager/reps_to_review_arrow.png")
                                  }
                                })
                              ]
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    objective.objectiveType == "Form" &&
                    objective.CompletionPercentage == 100
                      ? _c(
                          "div",
                          {
                            staticClass: "col-4 col-xl-4 pr-0 text-right",
                            staticStyle: { "padding-left": "5px" }
                          },
                          [
                            _c(
                              "a",
                              {
                                staticClass:
                                  "progress_item_link font-weight-bold",
                                on: {
                                  click: function($event) {
                                    return _vm.goToViewForm(
                                      objective.objectiveId
                                    )
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(objective.buttonName) + " \n        "
                                ),
                                _c("img", {
                                  staticClass: "ml-2 objective-view-icon",
                                  attrs: {
                                    src: require("@/assets/manager/reps_to_review_arrow.png")
                                  }
                                })
                              ]
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    objective.objectiveType == "Course" &&
                    objective.CompletionPercentage == 100
                      ? _c(
                          "div",
                          {
                            staticClass: "col-4 col-xl-4 pr-0 text-right",
                            staticStyle: { "padding-left": "5px" }
                          },
                          [
                            _c(
                              "a",
                              {
                                staticClass:
                                  "progress_item_link font-weight-bold",
                                on: {
                                  click: function($event) {
                                    return _vm.viewCourseReport(objective.cert)
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(objective.buttonName) + " \n        "
                                ),
                                _c("img", {
                                  staticClass: "ml-2 objective-view-icon",
                                  attrs: {
                                    src: require("@/assets/manager/reps_to_review_arrow.png")
                                  }
                                })
                              ]
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    objective.objectiveType == "Task List"
                      ? _c(
                          "div",
                          {
                            staticClass: "col-4 col-xl-4 pr-0 text-right",
                            staticStyle: { "padding-left": "5px" }
                          },
                          [
                            _c(
                              "a",
                              {
                                staticClass:
                                  "progress_item_link font-weight-bold",
                                on: {
                                  click: function($event) {
                                    $event.preventDefault()
                                    return _vm.openTaskListModal(
                                      objective.objectiveId
                                    )
                                  }
                                }
                              },
                              [
                                _vm._v("Skills \n        "),
                                _c("img", {
                                  staticClass: "ml-2 objective-view-icon",
                                  attrs: {
                                    src: require("@/assets/manager/reps_to_review_arrow.png")
                                  }
                                })
                              ]
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    objective.objectiveType == "Certificate"
                      ? _c(
                          "div",
                          {
                            staticClass: "col-4 col-xl-4 pr-0 text-right",
                            staticStyle: { "padding-left": "5px" }
                          },
                          [
                            _c(
                              "a",
                              {
                                staticClass:
                                  "progress_item_link font-weight-bold",
                                on: {
                                  click: function($event) {
                                    $event.preventDefault()
                                    return _vm.openCertificationModal(
                                      objective.objectiveId
                                    )
                                  }
                                }
                              },
                              [
                                _vm._v("Certifications \n        "),
                                _c("img", {
                                  staticClass: "ml-2 objective-view-icon",
                                  attrs: {
                                    src: require("@/assets/manager/reps_to_review_arrow.png")
                                  }
                                })
                              ]
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    objective.objectiveType == "External Course" &&
                    objective.CompletionPercentage != 100 &&
                    objective.buttonName == "Upload Certification" &&
                    _vm.checkIsManager()
                      ? _c(
                          "div",
                          {
                            staticClass: "col-4 col-xl-4 pr-0 text-right",
                            staticStyle: { "padding-left": "5px" }
                          },
                          [
                            _c(
                              "a",
                              {
                                staticClass:
                                  "progress_item_link font-weight-bold",
                                on: {
                                  click: function($event) {
                                    return _vm.openCourseCertificationModal(
                                      objective.objectiveId,
                                      objective.id
                                    )
                                  }
                                }
                              },
                              [
                                _vm._v(_vm._s(objective.buttonName) + " "),
                                _c("img", {
                                  staticClass: "ml-2 objective-view-icon",
                                  attrs: {
                                    src: require("@/assets/manager/reps_to_review_arrow.png")
                                  }
                                })
                              ]
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    objective.objectiveType == "External Course" &&
                    objective.CompletionPercentage != 100 &&
                    objective.buttonName == "Approve Certification" &&
                    _vm.checkIsManager()
                      ? _c(
                          "div",
                          {
                            staticClass: "col-4 col-xl-4 pr-0 text-right",
                            staticStyle: { "padding-left": "5px" }
                          },
                          [
                            _c(
                              "a",
                              {
                                staticClass:
                                  "progress_item_link font-weight-bold",
                                on: {
                                  click: function($event) {
                                    return _vm.approveCertificationModalOpen(
                                      objective.objectiveId,
                                      objective.id
                                    )
                                  }
                                }
                              },
                              [
                                _vm._v(_vm._s(objective.buttonName) + " "),
                                _c("img", {
                                  staticClass: "ml-2 objective-view-icon",
                                  attrs: {
                                    src: require("@/assets/manager/reps_to_review_arrow.png")
                                  }
                                })
                              ]
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    objective.objectiveType == "External Course" &&
                    objective.CompletionPercentage == 100
                      ? _c(
                          "div",
                          {
                            staticClass: "col-4 col-xl-4 pr-0 text-right",
                            staticStyle: { "padding-left": "5px" }
                          },
                          [
                            _c(
                              "a",
                              {
                                staticClass:
                                  "progress_item_link font-weight-bold",
                                on: {
                                  click: function($event) {
                                    return _vm.downloadCourseFunc(
                                      objective.fileName
                                    )
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(objective.buttonName) + " \n        "
                                ),
                                _c("img", {
                                  staticClass: "ml-2 objective-view-icon",
                                  attrs: {
                                    src: require("@/assets/manager/reps_to_review_arrow.png")
                                  }
                                })
                              ]
                            )
                          ]
                        )
                      : _vm._e()
                  ])
                ]
              )
            : _vm._e()
        }),
        0
      ),
      _vm._v(" "),
      _vm.isTaskListModalVisible
        ? _c(
            "div",
            [
              _c("MenteeTasklists", {
                ref: "TaskListModal",
                attrs: {
                  isModalVisible: _vm.isTaskListModalVisible,
                  type: _vm.type
                },
                on: {
                  close: _vm.closeTaskListModal,
                  closeTaskListModal: _vm.closeTaskListModal,
                  closeAddRep: _vm.closeAddRep
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.isCertificationModalVisible
        ? _c(
            "div",
            [
              _c("MenteeCertifications", {
                ref: "CertificationModal",
                attrs: {
                  isModalVisible: _vm.isCertificationModalVisible,
                  type: _vm.type
                },
                on: {
                  close: _vm.closeCertificationModal,
                  closeTaskListModal: _vm.closeCertificationModal
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.isCourseCertificationModalVisible
        ? _c(
            "div",
            [
              _c("MenteeUploadCourseCertifications", {
                ref: "CourseCertificationModal",
                attrs: {
                  isModalVisible: _vm.isCourseCertificationModalVisible,
                  type: _vm.type
                },
                on: {
                  close: _vm.closeCourseCertificationModal,
                  closeTaskListModal: _vm.closeCourseCertificationModal
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.isMenteeApproveComponentVisible
        ? _c(
            "div",
            [
              _c("MenteeApproveCertificate", {
                ref: "MenteeApproveModal",
                attrs: {
                  isModalVisible: _vm.isMenteeApproveComponentVisible,
                  type: _vm.type
                },
                on: {
                  close: _vm.approveCertificationModalClose,
                  closeMenteeApproveModal: _vm.approveCertificationModalClose
                }
              })
            ],
            1
          )
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "text-uppercase h3 mb-0 text-success" }, [
      _c("img", {
        attrs: { src: require("@/assets/manager/objective_completed.png") }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "text-uppercase h3 mb-0 text-success" }, [
      _c("img", {
        attrs: { src: require("@/assets/manager/objective_not_completed.png") }
      })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-507242e1", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-507242e1","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/manager/dashboard_mentee_progress.vue
// module id = null
// module chunks = 